<div class="wrapper">{{text}}</div>
